import React, { useState, useEffect, useCallback } from "react";
import { CancelRequest } from "../../../services/AxiosInstance";
import Pagination from "../../constant/Pagination";
import TableLoaderEffect from "../../constant/TableLoader";
import DebounceSearchInput from "../../constant/DebounceSearchInput";
import { getInstrumentListApi } from "../../../services/CalibrationService";
import { Button } from "react-bootstrap";
import EditCalibration from "./EditCalibration";
import AddInstrument from "./AddInstrument";
import EditInstrument from "./EditInstrument";

const Instrument = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [query, setSearchQuery] = useState("");
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const recordsPage = 25;

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    getInstrumentListApi(currentPage, recordsPage, query)
      .then((resp) => {
        setData(resp.data.results);
        setTotal(resp.data.total);
      })
      .catch((error) => {
        console.error(error.response?.data?.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage, query]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handleSearchChange = (value) => {
    CancelRequest();
    setSearchQuery(value);
    setCurrentPage(1);
  };

  const handleAfterCreate = (newData) => {
    setData((prevData) => [newData, ...prevData]);
    setTotal((prevTotal) => prevTotal + 1);
};

  const handleAfterUpdate = (updatedData) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === updatedData.id ? { ...item, ...updatedData } : item
      )
    );
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-header">
                <h3 className="mb-0">Instrument List</h3>
                <div className="table-left-header">
                  <div className="form-group me-3">
                    <DebounceSearchInput handleSearchChange={handleSearchChange} />
                  </div>
                  <AddInstrument handleAfterCreate={handleAfterCreate} />
                </div>
              </div>

              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                <table
                  id="empoloyees-tblwrapper"
                  className="table ItemsCheckboxSec dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th className="fw-bold">Name</th>
                      <th className="fw-bold">Serial Number</th>
                      <th className="fw-bold">Description</th>
                      <th className="fw-bold">File</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <TableLoaderEffect colLength={5} />
                    ) : (
                      data?.map((item, index) => (
                        <tr key={index}>
                          <td>
                          <EditInstrument
                              data={item}
                              handleAfterUpdate={handleAfterUpdate}
                            />
                          </td>
                          <td>{item?.serial_number}</td>
                          <td
                            className="text-wrap"
                            style={{ maxWidth: "300px" }}
                          >
                            {item.description}
                          </td>
                          <td>
                            {item?.photo ? (
                              <Button
                                variant="info"
                                className="btn-sm"
                                href={`${process.env.REACT_APP_BASE_URL}${item?.photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="fa-solid fa-file-arrow-down me-2"></i>
                                View File
                              </Button>
                            ) : (
                              "No file"
                            )}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {isLoading ? (
                <div style={{ height: "4rem" }}></div>
              ) : (
                <Pagination
                  currentPage={currentPage}
                  recordsPage={recordsPage}
                  dataLength={total}
                  handlePagination={handlePagination}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Instrument;
